<div>
  <div class="row mb-4">
    <div class="col-6">
      <span class="fw-bold">Date de la visite : </span>
      <span>{{ informationsBien.viewingDate | date: "dd/MM/yyyy" }}</span>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-12">
      <span class="fw-bold">Description du bien : </span>
      <div>{{ informationsBien.description }}</div>
    </div>
  </div>

  <div class="mb-4">
    <span class="fw-bold">Description de l’environnement du bien : </span>
    <div>{{ informationsBien.surroundingsDescription }}</div>
  </div>

  <div class="row mb-4">
    <div class="col-6">
      <span class="fw-bold">Etat du bien et travaux à prévoir : </span>
      <div>{{ informationsBien.condition }}</div>
    </div>

    <div class="col-6">
      <span class="fw-bold">Etat d’occupation : </span>
      <span>{{ informationsBien.occupation }}</span>
    </div>
  </div>

  <div class="mb-4">
    <span class="fw-bold">Commentaires : </span>
    <div>{{ informationsBien.comments }}</div>
  </div>
</div>
